import { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import AudioPlayer from "@/components/AudioPlayer";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Gallery from "@/components/Gallery";
import Manifesto from "@/components/Manifesto";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import LegalModal from "@/components/LegalModal";
import CookieBanner from "@/components/CookieBanner";

function App() {
  const [legalType, setLegalType] = useState(null);

  return (
    <div className="App bg-pearl">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Outfit, sans-serif" } }} />
      <SmoothScroll>
        <Navbar />
        <AudioPlayer />
        <main>
          <Hero />
          <EditorialMarquee />
          <Gallery />
          <Manifesto />
          <Contact />
        </main>
        <Footer onOpenLegal={setLegalType} />
      </SmoothScroll>

      <LegalModal 
        isOpen={legalType !== null} 
        onClose={() => setLegalType(null)} 
        type={legalType} 
      />

      <CookieBanner onOpenDatenschutz={() => setLegalType("datenschutz")} />
    </div>
  );
}

export default App;
